import React from "react";

import { Select } from "components/forms";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import { FloatType } from "store/types/deal/debt";
import { SelectChangeEvent } from "@mui/material";

import { FormValues } from "../schemas";

interface Props {
  name: "float_type" | "pik_float_type";
  formik: FormikProps<FormValues>;
  label?: string;
  disabled?: boolean;
  size?: "small" | "medium";
  onChange?: (e: SelectChangeEvent<FloatType>) => void;
}

export const FloatTypeSelect: React.FC<Props> = ({ name, formik, label, disabled = false, size, onChange }) => {
  const { t } = useTranslation("debt");

  const items = [
    { key: "fixed", value: "fixed", text: t("floatType.fixed") },
    { key: "linked", value: "linked", text: t("floatType.linked") },
    { key: "spread", value: "spread", text: t("floatType.spread") }
  ];

  return (
    <Select<FloatType>
      disabled={disabled}
      name={name}
      label={label ?? t("interestSection.interestType")}
      value={formik.values[name]}
      variant="outlined"
      fullWidth
      size={size}
      items={items}
      error={formik.touched[name] && Boolean(formik.errors[name])}
      helperText={formik.touched[name] ? (formik.errors[name] as string) : undefined}
      onChange={onChange ?? formik.handleChange}
    />
  );
};
